import loadable from 'react-loadable'
import PageLoader from '../PageLoader'

const LoadableOrderTracking = loadable({
	loader: () => import('./OrderTracking'),
	loading: PageLoader
})

export default React.memo(props => <LoadableOrderTracking {...props}/>)